import script from "./CollapsibleArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsibleArticle.vue?vue&type=script&setup=true&lang=js"

import "./CollapsibleArticle.vue?vue&type=style&index=0&id=576c965b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576c965b"]])

export default __exports__